export const DDWA_INITIATE_PROPOSAL_FORM_ID = 'ddwa-initiate-proposal-form';
